import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, IonRouterOutlet } from '@ionic/angular';

import { AuthService } from './../../providers/auth-service/auth-service';
import { CanActivate, ActivatedRouteSnapshot ,Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { TranslationBridge } from 'src/app/providers/translation-bridge/translation-bridge';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  host: {
    'class': 'accent-page'
  }
})
export class LoginPage implements OnInit {

  mode: string = "login";
  layout: string = "full";

  loading: boolean = false;

  email: string;
  password: string;

  displayName: string;

  error: string;
  success: string = "";
  info: string;

  validInvitation: boolean = false;
  invitationCode: string;

  workspaceId: string;
  workspaceInvitationCode: string;

  constructor(
    private auth: AuthService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private http: HttpClient,
    private translate: TranslationBridge,
    public navCtrl: NavController) { }

    ngOnInit(){
      this.activatedRoute.queryParams.subscribe(params => {

        let returnURL = this.activatedRoute.snapshot.queryParamMap.get('return');

        let returnURLObject = returnURL ? returnURL.split('/') : [];

        if(returnURL && returnURL.indexOf('quick') != -1){
          this.layout = "quick";
        }

        if(returnURL){
          this.info = this.translate.get('LOGIN_INFO_NEED_TO_BE_LOGGED_IN');
        }

        // Invitation Acception
        if(returnURLObject.length >= 4 && returnURLObject[1] == 'invites' && returnURLObject[4] == 'accept'){
          this.workspaceId = returnURLObject[2];
          this.workspaceInvitationCode = returnURLObject[3];
          this.info = this.translate.get('LOGIN_RECEIVED_INVITATION');
          this.validInvitation = true;
        }

        if(params['mode']){
          this.mode = params['mode'];
        } else {
          this.mode = 'login';
        }
        if(this.mode == "logout"){
          this.success =  this.translate.get('LOGIN_YOU_ARE_NOW_LOGGED_OUT');
          this.mode = "login";
          this.router.navigate(['/login'], { queryParams: { mode: this.mode } });
        }
      });
    }

    /*
      login
    */
    async performLogin() {

      this.error = "";
      this.success = "";
      this.loading = true;

      if(  !this.email
        || !this.password){
        this.loading = false;
        this.error = this.translate.get('LOGIN_INFORMATION_REQUIRED');
        return false;
      }

      // redirect url based on get param "return"
      let returnURL = this.activatedRoute.snapshot.queryParamMap.get('return');
      if(!returnURL) returnURL = "/dashboard";

      // perform login
      this.auth.emailLogin(this.email,this.password).then( async (user) => {
        setTimeout(() => {
          if (user) {
            this.loading = false;
            this.error = "";
            // success
            this.navCtrl.navigateRoot(returnURL,{ replaceUrl: true });
          } else {
            this.loading = false;
            this.navCtrl.navigateRoot(returnURL,{ replaceUrl: true });
          }
        }, 700);
      }, async (error) => {
        this.loading = false;
        this.error = error.message;
        console.log(error);
        if(error.code == "auth/user-not-found"){
          this.error = this.translate.get('LOGIN_USER_NOT_FOUND');
        } else if(error.code == "auth/wrong-password" || error.code == "auth/invalid-login-credentials"){
          this.error = this.translate.get('LOGIN_WRONG_PASSWORD');
        } else if(error.code == "auth/too-many-requests"){
          this.error = this.translate.get('LOGIN_TOO_MANY_REQUESTS');
        } else if(error.code == "auth/invalid-email"){
          this.error = this.translate.get('LOGIN_INVALID_EMAIL');
        } else {
          this.error = error.message;
        }
      });
    }

    /*
      validate invitation code
    */
    async validateInvitationCode() {
      this.error = "";
      this.success = "";
      this.loading = true;

      if(!this.invitationCode){
        this.loading = false;
        this.error = this.translate.get('LOGIN_INVITATION_CODE_REQUIRED');
        return false;
      }

      this.http.get(environment.systemAPI + '/beta/redeem/'+this.invitationCode).toPromise().then((result:any) => {
        if(result.valid){
          this.validInvitation = true;
          this.loading = false;
          this.success = this.translate.get('LOGIN_INVITATION_CODE_VALID');
        } else {
          this.loading = false;
          if(result.message){ 
            this.error = result.message;
          } else {
            this.error = this.translate.get('LOGIN_INVITATION_CODE_NOT_VALID');
          }
        }
      }).catch((error) => {
        this.loading = false;
        if(error?.error?.message){ 
          this.error = error.error.message;
        } else {
          this.error = this.translate.get('LOGIN_INVITATION_CODE_NOT_VALID');
        }
      });

    }

    /*
      signup
    */
    async performSignup() {

      this.error = "";
      this.success = "";
      this.loading = true;

      if(  !this.email
        || !this.password
        || !this.displayName){
        this.loading = false;
        this.error = this.translate.get('LOGIN_SIGNUP_INFORMATION_REQUIRED');
        return false;
      }

      // perform login
      this.auth.emailSignup(this.email,this.password,this.displayName).then( async (user) => {

        // send the verification mail
        this.auth.sendVerificationMail();

        setTimeout(() => {  
          this.http.post(environment.systemAPI + '/beta/redeem/'+this.invitationCode, {
            uid: (user.uid ? user.uid : user.user.uid),
            code: this.invitationCode
          }).toPromise().then((result:any) => {

          }).catch((error) => {

          });
        }, 400);

        setTimeout(() => {  
          if (user) {
            // maybe keep loading.. some times the navigation needs a moment
            // this.loading = false;
            this.error = "";
            // success
            this.navCtrl.navigateRoot('/setup',{ replaceUrl: true });
          } else {
            // maybe keep loading.. some times the navigation needs a moment
            // this.loading = false;
            this.navCtrl.navigateRoot('/setup',{ replaceUrl: true });
          }     

        }, 1000);

      }, async (error) => {
        this.loading = false;
        this.error = error.message;
      });
    }

    /*
      send password reset
    */
    async performPasswordReset() {

      this.error = "";
      this.success = "";
      this.loading = true;

      if(  !this.email ){
        this.loading = false;
        this.error = this.translate.get('LOGIN_EMAIL_REQUIRED');
        return false;
      }

      // perform login
      this.auth.forgotPassword(this.email).then( async () => {
          this.loading = false;
          // success
          this.error = "";
          this.success = this.translate.get('LOGIN_PASSWORD_RESET_EMAIL_SENT');
          this.router.navigate(['/login'], { queryParams: { mode: "login" } });
          this.mode = "login";
      }, async (error) => {
        this.loading = false;

        this.error = error.message;
        if(error.code == "auth/user-not-found"){
          this.error = this.translate.get('LOGIN_USER_NOT_FOUND');
        } else if(error.code == "auth/wrong-password"){
          this.error = this.translate.get('LOGIN_WRONG_PASSWORD');
        } else if(error.code == "auth/too-many-requests"){
          this.error = this.translate.get('LOGIN_TOO_MANY_REQUESTS');
        } else if(error.code == "auth/invalid-email"){
          this.error = this.translate.get('LOGIN_INVALID_EMAIL');
        } else {
          this.error = error.message;
        }


      });
    }

    setMode(mode: string, ev: any){
      ev.preventDefault();
      ev.stopPropagation();
      if(this.loading) return false;
      this.error = "";
      this.success = "";
      this.mode = mode;
      this.router.navigate(['/login'], { queryParams: { mode: mode } });
    }

  }
